let dd = require("ES/lib/dd");
let ProOnly = require("../../../../widgets/ProOnly");
let MiscForm = require("./MiscForm");
let StoriesTold = require("./StoriesTold");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");

let CSP = AuthedUserSession.is_privatelabel
	? null
	: require("./CSP");

module.exports = dd.createClass({
	render: function(){
		let {event, Displaylists} = this.props;
		let is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);

		return dd.div({className: "Misc"},
			dd.h2({style: {marginBottom: 0}}, "Misc"),
			MiscForm({
				event,
				Displaylists,
				read_only: AuthedUserSession.privatelabel_code === "cs" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
				is_limited_speaker: is_limited_speaker
			}),

			ProOnly({
					sids: event.sids,
					custom_message: "Working toward your CSP? eSpeakers tracks all of the information needed for the CSP application, and generates the NSA-required application spreadsheet. PRO users also avoid repeating content by tracking stories told at each event."
				},

				CSP ? CSP({form_section_name: "CSP", event, Displaylists}) : null,

				StoriesTold({event, Displaylists})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/misc/index.js